module.exports = __webpack_public_path__ + "img/multiplier_16.c9406a93.png";